const AvailableBands = [
	{
		"value": "0",
		"label": "Select"
	},
	{
		"value": "24",
		"label": "24+ (4.5 Bands)"
	},
	{
		"value": "31",
		"label": "31+ (5.0 Bands)"
	},
	{
		"value": "39",
		"label": "39+ (5.5 Bands)"
	},
	{
		"value": "47",
		"label": "47+ (6.0 Bands)"
	},
	{
		"value": "55",
		"label": "55+ (6.5 Bands)"
	},
	{
		"value": "63",
		"label": "63+ (7.0 Bands)"
	},
	{
		"value": "71",
		"label": "71+ (7.5 Bands)"
	},
	{
		"value": "79",
		"label": "79+ (8.0 Bands)"
	},
	{
		"value": "86",
		"label": "86+ (8.5 Bands)"
	},
	{
		"value": "90",
		"label": "90+ (9.0 Bands)"
	}
];
export default AvailableBands;